import { Component, OnInit, Input } from '@angular/core';
import { FELObj } from '../../models/fel/felobj';
import { resultado_certificacion } from '../../models/fel/resultado_certificacion';
import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer/ngx';
import { File } from '@ionic-native/file/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
import { UsuarioService } from 'src/app/services/usuario.service';
import { LoadingService } from 'src/app/services/loading.service';
import { WordPressService } from 'src/app/services/word-press.service';
import { Producto } from 'src/app/models/producto';
import { SharingService } from 'src/app/services/sharing.service';

@Component({
  selector: 'app-pop-orden',
  templateUrl: './pop-orden.component.html',
  styleUrls: ['./pop-orden.component.scss'],
})
export class PopOrdenComponent implements OnInit {

  @Input() resultado: resultado_certificacion;
  @Input() ordenId: string;
  FechaResumen: Date;
  isNative: Boolean;
  personaId: string;
  urlPOSWC: string;
  consumerKey: string;
  consumerSecret: string;
  usuario: any;

  constructor(private printer: Printer,
    private file: File,
    private nativeHTTP: HTTP,
    private fileOpener: FileOpener,
    private ft: FileTransfer,
    public usuarioService: UsuarioService,
    private loadingService: LoadingService,
    public wordPressService: WordPressService,
    private sharingService: SharingService) {   }

  ngOnInit() {
    //console.log("pop facturador")
    this.FechaResumen = new Date();
    //console.log(this.resultado);
    //console.log("endpop facturador")
    if(localStorage.getItem("isNative")=="false"){
      this.isNative=false;
    }else{
      this.isNative=true;
    }
  }

  ionViewDidEnter(){
    this.FechaResumen = new Date();
    this.credencialesWP();
  }

  imprimir()
  {
     let downloadUrl = 'https://files.swigit.gt/' + localStorage.getItem("nit_emisor") + '/ticket-' +  this.resultado.uuid + '.pdf';
   //  let downloadUrl = 'https://files.swigit.gt/' + "11400049K" + "/" + this.resultado.uuid + '.pdf';
     let path = this.file.dataDirectory;
     // window.open(downloadUrl);
    console.warn("empezo descarga");
     const transfer = this.ft.create(); //download the file
     transfer.download(downloadUrl, `${path}` + this.resultado.uuid + '.pdf')
     .then(entry => {
      console.warn("llego descarga");
       let url = entry.toURL();
       console.warn("URL: " + url);
      //  this.fileOpener.open(url, 'application/pdf');
      this.printPDF(url);
     }
     ,
     error=>
     {
      console.warn("ERROR EN DESCARGA: " + error);
     });

     /*
     this.nativeHTTP.downloadFile(downloadUrl,{},{}, path + this.resultado.uuid + ".pdf").then(
       data=>
       {
        this.fileOpener.open(path + this.resultado.uuid + ".pdf", 'application/pdf');
          console.log("DESCARGO CON EXITO: path: " + path + " url: " + data.url + " data: "+ data.data);
       },
       error =>
       {
          console.log("DESCARGO CON ERROR: " + error.error + ": STATUS:" + error.status);
       }
     )
     */

  }

  printPDF(URLticket)
  {
    let options: PrintOptions = {
      name: 'MyDocument',
      duplex: false,
      orientation: 'portrait',
      monochrome: true
    }

    this.printer.isAvailable().then(
      data =>
      {
        console.log("IMPRESORA HABILITADA: " + data);
        this.printer.print(URLticket, options).then(
          exito=>
          {
            console.log("IMPRIMIO CON EXITO: " + exito);
          },
          error=>
           {
            console.log("ERROR AL IMPRIMIR: " + error);
           });
      },
      error =>
      {
        console.log("ERROR IMPRESORA NO HABILITADA: " + error);
      } );
  }

 
  descargar()
  {
    let downloadUrl = 'https://files.swigit.gt/' + localStorage.getItem("nit_emisor") + '/' +  this.resultado.uuid + '.pdf';
    window.open(downloadUrl);
  }

  verPedido()
  {
    let verPedidoUrl = "https://" + this.urlPOSWC + "/wp-admin/post.php?post=" + this.ordenId + "&action=edit";
    window.open(verPedidoUrl);
  }

  credencialesWP()
  {
    this.personaId = localStorage.getItem("personaId");
    this.usuario = this.usuarioService.getUsuario(this.personaId).subscribe(data =>
      {
        this.usuario = data;
        let tieneLlavesWC: boolean = this.usuario.urlPOSWC == null ? false: true;
            if(tieneLlavesWC == true)
            {
              this.urlPOSWC = this.usuario.urlPOSWC;
              this.consumerKey = this.usuario.consumerKey;
              this.consumerSecret = this.usuario.consumerSecret;
            }
      },
      error => {
        console.log(error);
       
      });
  }

  cargarProductosWC(url, consumer_key, consumer_secret)
  {
    this.loadingService.present();
    this.usuario = this.wordPressService.getProductosWC(url, consumer_key, consumer_secret).subscribe(data =>
      {
        console.log("LLEGO DATA WOOCOMMERCE");
        console.log(data);
        let listaProducto : Producto[] = [];
        
        let listaWC = data as any;

        listaWC.forEach(function (item, index) {
          let productoItem = new Producto(0, "", "", "", 0, "", 0, false, false, "" );
          productoItem.nombre = item.name;
          productoItem.descripcion = "";
          productoItem.inventario = item.stock_quantity;
          productoItem.esServicio = (item.stock_quantity == null && item.in_stock == true) ? true : false;
          productoItem.id = item.id;
          productoItem.precio = (Number)(item.price);
          productoItem.sku = item.sku;
          productoItem.urlImagen = item.images[0].src;
          productoItem.codigoBarras = item.meta_data.find(meta => meta.key == "qr_swigit") != null ? item.meta_data.find(meta => meta.key == "qr_swigit").value : ""; // meta_data -> recorrer buscando un ID o llave que creemos nosotros "qrswigit" -> en el value guardar los códigos de barra
          productoItem.variable = item.variations[0] != null ? true : false;
          listaProducto.push(productoItem);
       
        }
        );

        console.log("PRODUCTOS PRE CARGADOS EN POP ORDEN");
        console.log(listaProducto);
        this.sharingService.setProductoInfo(listaProducto);
     
        
        this.loadingService.dismiss();
        
        
       
      }
    );
  }

  ngOnDestroy()
  {
    console.log("LLEGO ONDESTROY POP ORDEN");
    this.cargarProductosWC(this.urlPOSWC, this.consumerKey, this.consumerSecret);
  }



}
